import { InputType, CheckoutSteps, ContentWidthDeviceSize, VerificationMethod, OfferIntentType } from './enums'

// String arrays mapped to enums
export const ItemStatusStrings: readonly string[] = [
  'Pending', // ItemStatus.Pending
  'In Trial', // ItemStatus.Trial
  'Active', // ItemStatus.Active
  'Cancelled', // ItemStatus.Cancelled
  'Declined', // ItemStatus.RecycleBillingFailed
  'Declined - Reattempting', // ItemStatus.RecycleBilling
  'Refunded', // ItemStatus.Refunded
  'Declined', // ItemStatus.Declined
  'Complete', // ItemStatus.Complete
  'Cancelled', // ItemStatus.Replaced
  'Paused', // ItemStatus.Paused
  'Cancelled', // ItemStatus.ThirdPartyCancel
  'Declined', // ItemStatus.RecycleFailedHold
  'Externally Managed', // ItemStatus.ThirdPartyManaged
] as const

export const ItemStatusClasses: readonly string[] = [
  'pending', // ItemStatus.Pending
  'active', // ItemStatus.Trial
  'active', // ItemStatus.Active
  'cancelled', // ItemStatus.Cancelled
  'cancelled', // ItemStatus.RecycleBillingFailed
  'pending', // ItemStatus.RecycleBilling
  'cancelled', // ItemStatus.Refunded
  'cancelled', // ItemStatus.Declined
  'active', // ItemStatus.Complete
  'cancelled', // ItemStatus.Replaced
  'pending', // ItemStatus.Paused
  'cancelled', // ItemStatus.ThirdPartyCancel
  'cancelled', // ItemStatus.RecycleFailedHold
  'active', // ItemStatus.ThirdPartyManaged
] as const

export const FulfillmentStatusStrings: readonly string[] = [
  'Pending', // FulfillmentStatus.Hold
  'Shipped', // FulfillmentStatus.Shipped
  'Delivered', // FulfillmentStatus.Delivered
  'Return Pending', // FulfillmentStatus.RMAPending
  'Returned', // FulfillmentStatus.Returned
  'Cancelled', // FulfillmentStatus.Cancelled
  'Processed', // FulfillmentStatus.Processing
  'Shipped', // FulfillmentStatus.PendingShipment
  'Failed', // FulfillmentStatus.Failed
  'No Shipment', // FulfillmentStatus.None
  'Next Cycle Product', // FulfillmentStatus.NextCycle
  'Cancelled', // FulfillmentStatus.Removed
  'Processing', // FulfillmentStatus.ProcessingReattempt
  'Skipped', // FulfillmentStatus.Skipped
  'No Shipment', // FulfillmentStatus.ParentOrder
  'Frozen', // FulfillmentStatus.Frozen
] as const

export const FulfillmentStatusClasses: readonly string[] = [
  'pending', // FulfillmentStatus.Hold
  'shipped', // FulfillmentStatus.Shipped
  'delivered', // FulfillmentStatus.Delivered
  'pending', // FulfillmentStatus.RMAPending
  'cancelled', // FulfillmentStatus.Returned
  'cancelled', // FulfillmentStatus.Cancelled
  'pending', // FulfillmentStatus.Processing
  'pending', // FulfillmentStatus.PendingShipment
  'cancelled', // FulfillmentStatus.Failed
  'unfulfilled', // FulfillmentStatus.None
  'pending', // FulfillmentStatus.NextCycle
  'cancelled', // FulfillmentStatus.Removed
  'pending', // FulfillmentStatus.ProcessingReattempt
  'cancelled', // FulfillmentStatus.Skipped
  'unfulfilled', // FulfillmentStatus.ParentOrder
  'pending', // FulfillmentStatus.Frozen
] as const

export const ItemPendingStatusStrings: readonly string[] = [
  'Not Pending', // ItemPendingStatus.NotPending
  'Cancel Pending', // ItemPendingStatus.Cancel
  'Return Pending', // ItemPendingStatus.Return
  'Exchange Pending', // ItemPendingStatus.Exchange
  'Cancel Subscription Pending', // ItemPendingStatus.CancelSubscription
] as const

export const TrackingStatusStrings: readonly string[] = [
  'Unknown', // TrackingStatus.Unknown
  'Pre-Transit', // TrackingStatus.PreTransit
  'In-Transit', // TrackingStatus.InTransit
  'Out for Delivery', // TrackingStatus.OutForDelivery
  'Delivered', // TrackingStatus.Delivered
  'Available for Pickup', // TrackingStatus.AvailableForPickup
  'Alert/Exception', // TrackingStatus.ReturnToSender
  'Undelivered', // TrackingStatus.Failure
  'Cancelled', // TrackingStatus.Cancelled
  'Alert/Exception', // TrackingStatus.Error
  'Not Found', // TrackingStatus.NotFound
  'Expired', // TrackingStatus.Expired
] as const

export const TrackingStatusDescriptionStrings: readonly string[] = [
  "Tracking number not found. The carrier hasn't updated this package yet, or the number may be invalid.",
  'Pending shipment. A label has been created and the carrier is waiting to receive the package.',
  'Your package is on the way.',
  'Your package is out for delivery, stay tuned!',
  'The package is delivered',
  'Ready for pickup at your local carrier facility.',
  "There's an issue with your delivery (such as return to sender, or package damage).",
  'Delivery attempt unsuccessful. The courier will typically retry or provide pickup instructions.',
  'No tracking updates received for an extended time. The package may not have progressed.',
  "There's an issue with your delivery (such as return to sender, or package damage).",
  "Tracking number not found. The carrier hasn't updated this package yet, or the number may be invalid.",
  'No tracking updates received for an extended time. The package may not have progressed.',
] as const

export const TrackingStatusMissingDeliverDateStrings: readonly string[] = [
  "We'll provide an estimated delivery date once your package begins its journey.",
  "We'll provide an estimated delivery date once your package begins its journey.",
  'Delivery date will be updated once available.',
  'Delivery date will be updated once available.',
  '',
  'Delivery date will be updated once available.',
  '',
  'Estimated delivery date will be available once the next attempt is scheduled.',
  '',
  '',
  '',
  '',
] as const

export const TrackingStatusClass: readonly string[] = [
  'failure', // TrackingStatus.Unknown
  'success', // TrackingStatus.PreTransit
  'success', // TrackingStatus.InTransit
  'success', // TrackingStatus.OutForDelivery
  'success', // TrackingStatus.Delivered
  'success', // TrackingStatus.AvailableForPickup
  'failure', // TrackingStatus.ReturnToSender
  'failure', // TrackingStatus.Failure
  'failure', // TrackingStatus.Cancelled
  'failure', // TrackingStatus.Error
  'failure', // TrackingStatus.NotFound
  'failure', // TrackingStatus.Expired
] as const

export const PaymentSourceStrings: readonly string[] = [
  'Credit Card', // PaymentSource.CreditCard
  'Check', // PaymentSource.Check
  'Pre-Paid', // PaymentSource.PrePaid
  'COD', // PaymentSource.COD
  'Direct Debit', // PaymentSource.DirectDebit
  'PayPal', // PaymentSource.PayPal
  'ApplePay', // PaymentSource.ApplePay
  'GooglePay', // PaymentSource.GooglePay
  'Other', // PaymentSource.Other
  'Shopify', // PaymentSource.Shopify
] as const

export const TranResponseStrings: readonly string[] = [
  'Success', // TranResponse.Success
  'Declined', // TranResponse.SoftDecline
  'Declined', // TranResponse.HardDecline
] as const

export const TranResponseBadgeClass: readonly string[] = [
  'active', // TranResponse.Success
  'declined', // TranResponse.SoftDecline
  'declined', // TranResponse.HardDecline
] as const

export const PaymentStatusStrings: readonly string[] = [
  'Unpaid',
  'Paid',
  'Refunded',
  'Declined',
  'Partially Refunded',
] as const

export const PaymentStatusClasses: readonly string[] = ['pending', 'active', 'refund', 'cancelled', 'refund'] as const

export const ManageSubscriptionIntents: readonly InputType[] = [
  InputType.ChangeInterval,
  InputType.ChangeSubscriptionVariant,
  InputType.ChangeSubscriptionProduct,
  InputType.SkipSubscription,
  InputType.PauseSubscription,
  InputType.CancelSubscription,
] as const

export const StepsExcludedFromMouseflow: readonly InputType[] = [
  InputType.Product,
  InputType.PaymentInfo,
  InputType.Faqs,
  InputType.ItemStatus,
  InputType.InputActionStatus,
  InputType.BillingAddress,
  InputType.ShippingAddress,
] as const

// Maps
export const CheckoutStepsTitle = {
  [CheckoutSteps.SelectItems]: 'Please select the item(s)',
  [CheckoutSteps.AddressInfo]: 'Shipping Information',
  [CheckoutSteps.PaymentInfo]: 'Payment Method',
  [CheckoutSteps.OrderPlaced]: 'Order Placed',
} as const

export const IntentLabels: Record<number, string> = {
  [InputType.Cancel]: 'Cancel Shipment',
  [InputType.Return]: 'Return Product',
  [InputType.ReturnTrial]: 'Return Product',
  [InputType.ReturnSubscription]: 'Return Product',
  [InputType.SkipSubscription]: 'Skip Shipment',
  [InputType.ChangeProduct]: 'Revise Package',
  [InputType.ChangeInterval]: 'Shipping Frequency',
  [InputType.PauseSubscription]: 'Pause Subscription',
  [InputType.CancelSubscription]: 'Cancel Subscription',
  [InputType.ReactivateSubscription]: 'Re-Activate',
  [InputType.CancelTrial]: 'Cancel Trial',
  [InputType.CancelSubscriptionHold]: 'Cancel Shipment',
  [InputType.CancelTrialHold]: 'Cancel Trial',
  [InputType.ChangeVariant]: 'Change Order Variant',
  [InputType.ChangeSubscriptionProduct]: 'Change Product',
  [InputType.ChangeSubscriptionVariant]: 'Change Subscription Variant',
  [InputType.CancelRebillHold]: 'Cancel Shipment',
  [InputType.OfferDetails]: 'Offer Details',
  [InputType.ShipmentTracking]: 'Track Shipment',
  [InputType.ItemStatus]: 'View Status',
  [InputType.ShippingProcessing]: 'Manage Order',
  [InputType.ReturnPending]: 'Manage Order',
} as const

// Labels used in place of IntentLabels when the item is non-shippable (digital).
export const DigitalIntentLabels: Record<number, string> = {
  [InputType.Cancel]: 'Cancel Order',
  [InputType.SkipSubscription]: 'Skip Cycle',
  [InputType.ChangeProduct]: 'Revise Order',
  [InputType.ChangeInterval]: 'Billing Frequency',
  [InputType.CancelSubscriptionHold]: 'Cancel Order',
  [InputType.CancelRebillHold]: 'Cancel Order',
} as const

// Maps a path InputType to its canonical OfferIntentType.
// Used by the retention modal to route to the correct offer flow.
export const IntentTypeMapping: Record<number, OfferIntentType> = {
  [InputType.Cancel]: OfferIntentType.Cancel,
  [InputType.CancelSubscription]: OfferIntentType.CancelSubscription,
  [InputType.Return]: OfferIntentType.Return,
  [InputType.ChangeInterval]: OfferIntentType.AdjustShippingFrequency,
  [InputType.PauseSubscription]: OfferIntentType.PauseSubscription,
  [InputType.SkipSubscription]: OfferIntentType.SkipSubscription,
  [InputType.ReactivateSubscription]: OfferIntentType.ReactivateSubscription,
  [InputType.ChangeProduct]: OfferIntentType.ReviseOrder,
  [InputType.ChangeQuantity]: OfferIntentType.ReviseOrder,
  [InputType.CancelTrial]: OfferIntentType.CancelTrial,
  [InputType.CancelSubscriptionHold]: OfferIntentType.CancelSubscriptionHold,
  [InputType.CancelTrialHold]: OfferIntentType.CancelTrialHold,
  [InputType.ReturnSubscription]: OfferIntentType.ReturnSubscription,
  [InputType.ReturnTrial]: OfferIntentType.ReturnTrial,
  [InputType.ChangeVariant]: OfferIntentType.ChangeVariant,
  [InputType.ChangeSubscriptionProduct]: OfferIntentType.ChangeSubscriptionProduct,
  [InputType.ChangeSubscriptionVariant]: OfferIntentType.ChangeSubscriptionVariant,
  [InputType.CancelRebillHold]: OfferIntentType.CancelRebillHold,
  [InputType.ShipmentTracking]: OfferIntentType.ShipmentTracking,
  [InputType.OfferDetails]: OfferIntentType.OfferDetails,
  [InputType.ItemStatus]: OfferIntentType.ItemStatus,
  [InputType.RebillItem]: OfferIntentType.RebillItem,
  [InputType.BillNow]: OfferIntentType.BillNow,
  [InputType.ShippingProcessing]: OfferIntentType.ShippingProcessing,
  [InputType.ReturnPending]: OfferIntentType.ReturnPending,
  [InputType.ExtendTrial]: OfferIntentType.ExtendTrial,
  [InputType.AdjustTrialFrequency]: OfferIntentType.AdjustTrialFrequency,
  [InputType.BillTrialNow]: OfferIntentType.BillTrialNow,
} as const

// Intent hierarchy — groups intents into categories for hierarchical display
export const IntentHierarchyCategory = {
  ManageOrder: 'manage_order',
  ManageSubscription: 'manage_subscription',
} as const

export const IntentHierarchyLabels: Record<string, string> = {
  [IntentHierarchyCategory.ManageOrder]: 'Manage Order',
  [IntentHierarchyCategory.ManageSubscription]: 'Manage Subscription',
} as const

export const IntentHierarchyMapping: Record<number, string> = {
  [InputType.ChangeVariant]: IntentHierarchyCategory.ManageOrder,
  [InputType.ChangeProduct]: IntentHierarchyCategory.ManageOrder,
  [InputType.Cancel]: IntentHierarchyCategory.ManageOrder,
  [InputType.CancelSubscriptionHold]: IntentHierarchyCategory.ManageOrder,
  [InputType.CancelRebillHold]: IntentHierarchyCategory.ManageOrder,
  [InputType.Return]: IntentHierarchyCategory.ManageOrder,
  [InputType.CancelTrialHold]: IntentHierarchyCategory.ManageOrder,
  [InputType.CancelTrial]: IntentHierarchyCategory.ManageOrder,
  [InputType.ReturnTrial]: IntentHierarchyCategory.ManageOrder,
  [InputType.ReturnSubscription]: IntentHierarchyCategory.ManageSubscription,
  [InputType.CancelSubscription]: IntentHierarchyCategory.ManageSubscription,
  [InputType.PauseSubscription]: IntentHierarchyCategory.ManageSubscription,
  [InputType.SkipSubscription]: IntentHierarchyCategory.ManageSubscription,
  [InputType.ChangeSubscriptionProduct]: IntentHierarchyCategory.ManageSubscription,
  [InputType.ChangeSubscriptionVariant]: IntentHierarchyCategory.ManageSubscription,
  [InputType.ChangeInterval]: IntentHierarchyCategory.ManageSubscription,
} as const

export const ContentWidthDeviceSizeToClass = {
  [ContentWidthDeviceSize.Desktop]: 'lg',
  [ContentWidthDeviceSize.Tablet]: 'md',
  [ContentWidthDeviceSize.Mobile]: 'sm',
} as const

// Countries and Regions
export const Countries = {
  US: 'United States of America',
  AU: 'Australia',
  CA: 'Canada',
  FR: 'France',
  DE: 'Germany',
  GB: 'United Kingdom',
  MX: 'Mexico',
} as const

interface RegionOption {
  readonly value: string
  readonly text: string
}

export const Regions: Record<string, readonly RegionOption[]> = {
  US: [
    { value: 'AL', text: 'Alabama' },
    { value: 'AK', text: 'Alaska' },
    { value: 'AZ', text: 'Arizona' },
    { value: 'AR', text: 'Arkansas' },
    { value: 'CA', text: 'California' },
    { value: 'CZ', text: 'Canal Zone' },
    { value: 'CO', text: 'Colorado' },
    { value: 'CT', text: 'Connecticut' },
    { value: 'DE', text: 'Delaware' },
    { value: 'DC', text: 'District Of Columbia' },
    { value: 'FL', text: 'Florida' },
    { value: 'GA', text: 'Georgia' },
    { value: 'GU', text: 'Guam' },
    { value: 'HI', text: 'Hawaii' },
    { value: 'ID', text: 'Idaho' },
    { value: 'IL', text: 'Illinois' },
    { value: 'IN', text: 'Indiana' },
    { value: 'IA', text: 'Iowa' },
    { value: 'KS', text: 'Kansas' },
    { value: 'KY', text: 'Kentucky' },
    { value: 'LA', text: 'Louisiana' },
    { value: 'ME', text: 'Maine' },
    { value: 'MD', text: 'Maryland' },
    { value: 'MA', text: 'Massachusetts' },
    { value: 'MI', text: 'Michigan' },
    { value: 'MN', text: 'Minnesota' },
    { value: 'MS', text: 'Mississippi' },
    { value: 'MO', text: 'Missouri' },
    { value: 'MT', text: 'Montana' },
    { value: 'NE', text: 'Nebraska' },
    { value: 'NV', text: 'Nevada' },
    { value: 'NH', text: 'New Hampshire' },
    { value: 'NJ', text: 'New Jersey' },
    { value: 'NM', text: 'New Mexico' },
    { value: 'NY', text: 'New York' },
    { value: 'NC', text: 'North Carolina' },
    { value: 'ND', text: 'North Dakota' },
    { value: 'OH', text: 'Ohio' },
    { value: 'OK', text: 'Oklahoma' },
    { value: 'OR', text: 'Oregon' },
    { value: 'PA', text: 'Pennsylvania' },
    { value: 'PR', text: 'Puerto Rico' },
    { value: 'RI', text: 'Rhode Island' },
    { value: 'SC', text: 'South Carolina' },
    { value: 'SD', text: 'South Dakota' },
    { value: 'TN', text: 'Tennessee' },
    { value: 'TX', text: 'Texas' },
    { value: 'UT', text: 'Utah' },
    { value: 'VT', text: 'Vermont' },
    { value: 'VI', text: 'Virgin Islands' },
    { value: 'VA', text: 'Virginia' },
    { value: 'WA', text: 'Washington' },
    { value: 'WV', text: 'West Virginia' },
    { value: 'WI', text: 'Wisconsin' },
    { value: 'WY', text: 'Wyoming' },
  ],
  CA: [
    { value: 'AB', text: 'Alberta' },
    { value: 'BC', text: 'British Columbia' },
    { value: 'MB', text: 'Manitoba' },
    { value: 'NB', text: 'New Brunswick' },
    { value: 'NL', text: 'Newfoundland and Labrador' },
    { value: 'NT', text: 'Northwest Territories' },
    { value: 'NS', text: 'Nova Scotia' },
    { value: 'NU', text: 'Nunavut' },
    { value: 'ON', text: 'Ontario' },
    { value: 'PE', text: 'Prince Edward Island' },
    { value: 'QC', text: 'Quebec' },
    { value: 'SK', text: 'Saskatchewan' },
    { value: 'YT', text: 'Yukon' },
  ],
} as const

// Constants
export const TranslateTestString = 'dandruff' as const

export const ForceLogoutErrorCodes = [401] as const // unauthorized

export const SESSION_BOOTSTRAP_MESSAGE = 'Please wait while we initialize your session...' as const

export const DEFAULT_LOGOUT_MESSAGE = 'You have been logged out.' as const

export const LOGOUT_SESSION_ENDED_COPY =
  "Your session has ended. Click below to start a new session and we'll be happy to help you again." as const

export const BASE_WIDTH = 430 as const

export const ExternalStepKey = '_external' as const

export const MessageDisplayTime = 5000 as const // 5 seconds

export const CustomerMatchMessages = ['Looking you up... hang tight!', 'Still searching... almost there!'] as const

export const CustomerVerifyMessages = ['Verifying info... one sec!', 'Double-checking... thanks for waiting!'] as const

export const ActionMessages: readonly string[][] = [
  [],
  ['Processing cancellation...', 'Finalizing... almost there!'],
  ['Processing return...', 'Finalizing return... hang tight!'],
  ['Setting up exchange...', 'Confirming details... one sec!'],
  ['Applying your offer...', 'Locking it in... hang on!'],
  ['Updating order...', 'Making changes... almost there!'],
  ['Applying discount...', 'Updating subscription... done soon!'],
  ['Upgrading order...', 'Adding upgrade... hold on!'],
  ['Adjusting subscription...', 'Updating plan... one sec!'],
  ['Processing refund & update...', 'Finalizing changes...'],
  ['Canceling... hold on!', 'Wrapping up... almost done!'],
  ['Applying your offer...', 'Locking it in... hang on!'],
  ['Pausing... one moment!', 'Hold in place... almost done!'],
  ['Finalizing purchase...', 'Processing... hang on!'],
  ['Processing payment...', 'Confirming... one sec!'],
  ['Extending return...', 'Updating eligibility...'],
  ['Updating details...', 'Finalizing changes...'],
  ['Reactivating...', 'Bringing it back...'],
  ['Checking your request...', 'Reviewing... hang tight!'],
  ['Updating address...', 'Saving... almost there!'],
  ['Saving payment info...', 'Securing details...'],
  ['Fetching tracking...', 'Locating package...'],
  ['Creating return label...', 'Generating... hold tight!'],
  ['Extending trial...', 'Updating... almost done!'],
] as const

// Verification method fields mapping
export const VerificationMethodFields = {
  [VerificationMethod.FullName]: ['first_name', 'last_name'],
  [VerificationMethod.LastName]: ['last_name'],
  [VerificationMethod.Street]: ['address'],
  [VerificationMethod.Zip]: ['zip'],
  [VerificationMethod.Address]: ['address', 'city', 'state', 'zip', 'country'],
  [VerificationMethod.BillingStreet]: ['address'],
  [VerificationMethod.BillingZip]: ['zip'],
  [VerificationMethod.BillingAddress]: ['address', 'city', 'state', 'zip', 'country'],
  [VerificationMethod.Phone]: ['phone'],
  [VerificationMethod.PartialPhone]: ['phone'],
  [VerificationMethod.Email]: ['email'],
  [VerificationMethod.PartialEmail]: ['email'],
} as const

// Image sizes for placeholder images
export const ImageSizes = {
  small: [100, 100],
  medium: [300, 300],
  large: [400, 400],
  original: [400, 400],
} as const
